import { render, staticRenderFns } from "./GlassesGroupFilteringMobile.vue?vue&type=template&id=6d36a142&scoped=true"
import script from "./GlassesGroupFilteringMobile.vue?vue&type=script&lang=js"
export * from "./GlassesGroupFilteringMobile.vue?vue&type=script&lang=js"
import style0 from "./GlassesGroupFilteringMobile.vue?vue&type=style&index=0&id=6d36a142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d36a142",
  null
  
)

export default component.exports